<script setup lang="ts">
import { RouterView } from 'vue-router'
import { storeToRefs } from "pinia";
import { onMounted } from "vue";
import { useAuthStore } from "./stores/auth-store";
import { useNaviStore } from "./stores/navigation-state";
import { useSettingStore } from "./stores/setting-store";
import Navigation from "./components/Navigation.vue";
import AppLoader from "./components/AppLoader.vue";
import SideNavigation from './layout/SideNavigation.vue';
import CentreActivatorModal from './components/CentreActivatorModal.vue';
import { useGoogleTagManagerStore } from "./stores/google-tag-manager-store.ts"
import { loadGtmHeadScript } from "./tools/load-gtm-script"
import { loadLocaleMessages } from "@/i18n";

const navigationStore = useNaviStore();
const authStore = useAuthStore();
const settingStore = useSettingStore();
const googleTagManagerStore = useGoogleTagManagerStore();

const { isAuthenticated, clubId } = storeToRefs(authStore);
const { html, adminAppUrl } = storeToRefs(navigationStore);
const { setting } = storeToRefs(settingStore);

onMounted(async () => {
  try {
    await authStore.authenticate();
    await settingStore.getSetting();
    await loadLocaleMessages(setting.value.languages, setting.value.preferredLanguage);
    if(!setting.value?.googleTagManagerId) {
      return;
    } else {
      loadGtmHeadScript(window, document, 'script', 'dataLayer', setting.value.googleTagManagerId);
      await googleTagManagerStore.getGTMDataLayer();
    }
  } catch (error: any) {
    console.log(error.response)
  }
});

</script>

<template>
  <template v-if="isAuthenticated">
    <header>
      <Navigation />
    </header>
    <div class="layout" v-if="html">
      <div class="d-flex flex-row content">
        <SideNavigation class="content-left brand-bgcolor"/>
        <div class="p-2 pt-3 flex-grow-1">
          <main>
            <RouterView :adminAppUrl="adminAppUrl" :clubId="clubId"/>
          </main>
        </div>
      </div>
    </div>
    <CentreActivatorModal />
  </template>
  <AppLoader v-if="!isAuthenticated || !html" />
</template>